var chunkMapping = {
	"120": [
		97120
	],
	"153": [
		82153
	],
	"414": [
		85414
	],
	"467": [
		2467
	],
	"468": [
		30468
	],
	"571": [
		37571
	],
	"590": [
		5590
	],
	"772": [
		51772
	],
	"784": [
		3784
	],
	"832": [
		59832
	],
	"836": [
		31836
	]
};
var idToExternalAndNameMapping = {
	"2467": [
		"default",
		"./RiskChart",
		134
	],
	"3784": [
		"default",
		"./FrontendAnalytics",
		134
	],
	"5590": [
		"default",
		"./CustomerListStandAlone",
		85712
	],
	"30468": [
		"default",
		"./FrontendLookups",
		85712
	],
	"31836": [
		"default",
		"./IdentityPage",
		85712
	],
	"37571": [
		"default",
		"./LoginTableStandAlone",
		85712
	],
	"51772": [
		"default",
		"./ExportsList",
		85712
	],
	"59832": [
		"default",
		"./BotDetectionTableStandAlone",
		85712
	],
	"82153": [
		"default",
		"./Alerts",
		134
	],
	"85414": [
		"default",
		"./RuleEngine",
		88463
	],
	"97120": [
		"default",
		"./FrontendCustomerDetail",
		1369
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}